import axios from '@/plugins/axios'
import { Message } from 'element-ui'

export default {
  namespaced: true,

  state: {
    loading: false,
    badActors: [],
    selectedRequest: {},
    selectedDisabled: {},
    order_column: 'created_at',
    order_type: 'desc',
    page: 1,
    page_size: 100,
    dialog: false,
    dialog_insert: false,
    dialog_review: false,
    dialog_disabled: false,
    filter: {}
  },

  mutations: {
    setBadActors(state, payload) {
      state.badActors = payload
    },
    setSelectedRequest(state, payload) {
      state.selectedRequest = payload
    },
    setSelectedDisabled(state, payload) {
      state.selectedDisabled = payload
    },
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setOrdering(state, payload) {
      state.order_column = payload.column
      state.order_type = payload.type
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setDialog(state, payload) {
      state.dialog = payload
    },
    setDialogInsert(state, payload) {
      state.dialog_insert = payload
    },
    setDialogReview(state, payload) {
      state.dialog_review = payload
    },
    setDialogDisabled(state, payload) {
      state.dialog_disabled = payload
    },
    setFilter(state, payload) {
      state.filter = payload
    }
  },

  actions: {
    readBadActors({ commit, state }) {
      commit('setLoading', true)
      axios.admin
        .get('cms/youtube/whitelist', {
          params: {
            page: state.page,
            page_size: state.page_size,
            order_column: state.order_column,
            order_type: state.order_type,
            ...state.filter
          }
        })
        .then(r => {
          commit('setBadActors', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    insert({ commit, dispatch }, channelId) {
      axios.admin
        .post('cms/youtube/whitelist', {
          channelId: channelId
        })
        .then(() => {
          commit('setDialog', false)
          dispatch('readBadActors')
        })
        .catch(err => {
          if (err.response.data && err.response.data.response.message) {
            Message({
              type: 'error',
              message: err.response.data.response.message
            })
            commit('setDialog', false)
          }
        })
    },
    destroy({ dispatch }, id) {
      axios.admin.put('cms/youtube/whitelist/delete', { channels: id } )
          .then(() => {
        dispatch('readBadActors')
      })
    }
  }
}
